import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DefaultDialog, {
  DefaultDialogImplementationProps,
} from "@/features/Common/components/DefaultDialog";
import { trackEvent, trackUserInteraction } from "@/services/analytics-adapter";
import { getConfigurationVariable } from "@/services/configuration-adapter";
import ButtonWithAnalytics from "@/features/Common/components/ButtonWithAnalytics";

export default function NoOTPReceivedModal({
  isOpen,
  onClose,
  extras = {},
}: DefaultDialogImplementationProps) {
  const { t } = useTranslation();

  function onGetSupportLinkClick() {
    trackEvent({ event: "action.supportRequested", source: "no OTP received" });
    trackUserInteraction({
      linkText: `NoOTPReceivedModal | ${t("ReportAnIssue.reportAnIssueButton")}`,
      linkIntent: "navigational",
      linkScope: "button",
    });
  }

  return (
    <DefaultDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t("NoOTPReceivedModal.title")}
      actionButtons={
        <>
          <ButtonWithAnalytics
            page="NoOTPReceivedModal"
            text={t("NoOTPReceivedModal.resendOTPButton")}
            intent="navigational"
            size="small"
            onClick={extras.resendOTP}
          >
            {t("NoOTPReceivedModal.resendOTPButton")}
          </ButtonWithAnalytics>
          <Button
            component="a"
            href={getConfigurationVariable("VITE_APP_UNU_HEALTH_SUPPORT_URI")}
            onClick={onGetSupportLinkClick}
            target="_blank"
            variant="text"
            size="small"
          >
            {t("ReportAnIssue.reportAnIssueButton")}
          </Button>
        </>
      }
    >
      <Typography align="center">
        {t("NoOTPReceivedModal.body", {
          phoneNumber: extras.phoneNumber,
        })}
      </Typography>
    </DefaultDialog>
  );
}
